export default "__VITE_ASSET__Cw5lP_o2__"